import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-err-dialog',
  templateUrl: './err-dialog.component.html',
  styleUrls: ['./err-dialog.component.scss']
})
export class ErrDialogComponent implements OnInit {

  constructor(
    public config: DynamicDialogConfig,
  ) { }

  ngOnInit(): void {
    // this.config.data.message
  }

}
